/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { ContentType } from 'client-code/grid-guide';

import { Locale, LocaleKeys } from '../../../../core/locale';
import { OneLineGuideContentCellProps } from './OneLineGuideContentCellProps';

import './OneLineGuideContentCell.scss';

const OneLineGuideContentCell: FunctionComponent<OneLineGuideContentCellProps> = ({
    children,
    contentType,
    title,
    isAdult,
}) => {
    const className = [
        contentType === ContentType.Movie
            ? 'olg-content-cell type-movie'
            : 'olg-content-cell type-episodic',
        isAdult && 'is-adult',
    ]
        .filter(Boolean)
        .join(' ');

    const cellTitle = isAdult ? Locale.getString(LocaleKeys.GUIDE_TITLE_HIDDEN) : title;

    return (
        <div className={className}>
            {!isAdult && children}
            <div className="olg-content-cell-title-container">
                <p className="olg-content-cell-title">{cellTitle}</p>
            </div>
        </div>
    );
};

export default OneLineGuideContentCell;
